import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home/HomeView.vue'
import Overview from '../views/Overview/index.vue'
import Login from '../views/Login/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta:{
      needLogin:false  // 判断该路由是否需要登录
    },
  },
  {
    path: '/',
    component: HomeView,
    redirect:'/overview',
    meta:{
      needLogin:false
    },
    children: [
      {
        path: 'overview',
        name: 'Overview',
        meta:{
          needLogin:true
        },
        component: Overview,
      },
      {
        path: 'pro-display',
        name: 'proDisplay',
        meta:{
          needLogin:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ProDisplay/index.vue')
      },
      {
        path: 'patrol',
        name: 'patrol',
        meta:{
          needLogin:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/Patrol/index.vue')
      },
      {
        path: 'devExh',
        name: 'devExh',
        meta:{
          needLogin:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/DevExh/index.vue')
      },
      {
        path: 'statistical',
        name: 'statistical',
        meta:{
          needLogin:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/statAna/index.vue')
      },
    ]
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }

]

const router = new VueRouter({
  routes
})
export default router
